import OfficerLocationActionType from './officer-location-report.types';

/*********  START ADD CHECK IN DETAILS  *********/
export const getFieldOfficerListStart = (payload: any) => ({
	type: OfficerLocationActionType.GET_FIELD_OFFICER_LIST_START,
	payload,
});

export const getFieldOfficerListSuccess = (response: any) => ({
	type: OfficerLocationActionType.GET_FIELD_OFFICER_LIST_SUCCESS,
	response,
});

export const getFieldOfficerListFailure = (error: unknown) => ({
	type: OfficerLocationActionType.GET_FIELD_OFFICER_LIST_FAILURE,
	error,
});

export const getFieldOfficerListResponseReset = () => ({
	type: OfficerLocationActionType.GET_FIELD_OFFICER_LIST_RESPONSE_RESET,
});

export const getFieldOfficerListResponseChanged = () => ({
	type: OfficerLocationActionType.GET_FIELD_OFFICER_LIST_RESPONSE_CHANGED,
});
/*********  END ADD CHECK IN DETAILS  *********/

/*********  START GET CHECK IN LOCATION DETAILS  *********/
export const getFieldOfficerLocationStart = (payload: any) => ({
	type: OfficerLocationActionType.GET_FIELD_OFFICER_LOCATION_START,
	payload,
});

export const getFieldOfficerLocationSuccess = (response: any) => ({
	type: OfficerLocationActionType.GET_FIELD_OFFICER_LOCATION_SUCCESS,
	response,
});

export const getFieldOfficerLocationFailure = (error: unknown) => ({
	type: OfficerLocationActionType.GET_FIELD_OFFICER_LOCATION_FAILURE,
	error,
});

export const getFieldOfficerLocationResponseReset = () => ({
	type: OfficerLocationActionType.GET_FIELD_OFFICER_LOCATION_RESPONSE_RESET,
});

export const getFieldOfficerLocationResponseChanged = () => ({
	type: OfficerLocationActionType.GET_FIELD_OFFICER_LOCATION_RESPONSE_CHANGED,
});
/*********  END GET CHECK IN LOCATION DETAILS  *********/
